import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { CalculateQuantity } from "./../JobEnquiry/ListDataProjectJobEnquiry";
import { handleJEAssign } from "./RecAgencyFunction";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../../store/userSlice";

export default function JEAssignPopup({
  state,
  setState,
  recAgencyData,
  setAgencyData,
}) {
  const dispatch = useDispatch();
  const { vendor } = state?.data || {};
  console.log(state);

  const jobEnquiryList = recAgencyData?.job_enquiry?.filter(
    (job) => job.nationality_id == vendor?.nationality_id
  );

  const [selectedJobEnquiry, setSelectedJobEnquiry] = useState(null);

  const [submitLoading, setSubmitLoading] = useState(false);

  const handleAssign = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);
    handleJEAssign(state?.data?.id, selectedJobEnquiry)
      .then((response) => {
        setAgencyData(response?.data?.data);
        setSubmitLoading(false);
        dispatch(setAppError({ msg: response.data.message, color: "success" }));
        setState({ open: false });
      })
      .catch((error) => {
        setSubmitLoading(false);
        dispatch(
          setAppError({ msg: error?.response?.data?.message || error?.message })
        );
        setState({ open: false });
      });
  };
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center flex`}
    >
      <div className="max-w-xl w-full max-h-fit min-h-[15rem] rounded-md bg-white/95 flex flex-col py-4 px-8 relative">
        <div className="flex justify-between items-center w-full mt-1 mb-3">
          <h1 className="text-xl font-semibold">RECRUITMENT AGENCY DETAILS</h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => setState({ open: false })}
          >
            <IoMdClose />
          </h1>
        </div>
        <div className="flex flex-col w-full min-h-fit text-sm mx-auto rounded-md bg-slate-200 gap-[0.15rem]">
          <TableRow title={"Agency Name"} value={vendor?.name} />
          <TableRow title={"Agency Email"} value={vendor?.email} />
          <TableRow
            title={"Authorized Name"}
            value={vendor?.authorized_person_name}
          />
          <TableRow title={"NATIONAL ADDRESS"} value={vendor?.address} />
          <TableRow title={"COMPANY LANDLINE NUMBER"} value={vendor?.email} />
          <TableRow title={"COUNTRY"} value={vendor?.nationality?.name} />
          <div className="grid grid-cols-2 divide-x-2 divide-slate-200">
            <h1 className="p-2 bg-slate-100 font-semibold">JOB ENQUIRY NAME</h1>
            <div className="p-1 bg-slate-100">
              <select
                required
                className="select select-sm select-bordered w-full"
                onChange={(e) => setSelectedJobEnquiry(e.target.value)}
              >
                {jobEnquiryList.length <= 0 ? (
                  <option value="" selected hidden>
                    No Job Enquiry Available
                  </option>
                ) : (
                  <option value="" selected hidden>
                    Select Job Enquiry
                  </option>
                )}
                {jobEnquiryList.length > 0 &&
                  jobEnquiryList.map((jobEnquiry) => (
                    <option key={jobEnquiry.id} value={jobEnquiry.id}>
                      {jobEnquiry.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <TableRow
            title={"TOTAL QUANTITY"}
            value={CalculateQuantity(
              jobEnquiryList?.find((data) => data?.id == selectedJobEnquiry)
                ?.project_job_enquiry_cost_sheet_profession_basic_information
            )}
          />
        </div>
        <div className="flex gap-3 mx-auto my-3 w-full px-5 mt-5">
          <button
            className="p-2 px-4 rounded-md ring-1 ring-slate-300 max-w-xs w-full"
            onClick={() => setState({ open: false })}
            type="button"
          >
            Cancel
          </button>
          <button
            className={`p-2 px-4 rounded-md ring-1 ring-red bg-red text-white max-w-xs w-full flex items-center justify-center gap-2 ${
              !selectedJobEnquiry && "bg-red/80"
            }`}
            onClick={handleAssign}
            disabled={!selectedJobEnquiry ? true : false}
          >
            {submitLoading ? (
              <CgSpinner className="animate-spin mx-auto" />
            ) : (
              "Assign"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

const TableRow = ({ title, value }) => {
  return (
    <div className="grid grid-cols-2 divide-x-2 divide-slate-200">
      <h1 className="p-2 bg-slate-100 font-semibold">{title}</h1>
      <h1 className="p-2 bg-slate-100">{value}</h1>
    </div>
  );
};
